import { Button } from '@mui/material';

interface ResendCodeButtonProps {
  secondsLeft: number;
  isSending: boolean;
  onResend: () => void;
}

/** Stays in place through the cooldown, disabled and counting down, so the
 *  form does not shift when the option comes back. */
export const ResendCodeButton = ({
  secondsLeft,
  isSending,
  onResend,
}: ResendCodeButtonProps) => {
  const isCoolingDown = secondsLeft > 0;
  const label = isSending ? 'Sending…' : 'Resend code';

  return (
    <Button
      type="button"
      variant="text"
      onClick={onResend}
      disabled={isSending || isCoolingDown}
      fullWidth
    >
      {isCoolingDown ? `Resend in ${String(secondsLeft)}s` : label}
    </Button>
  );
};
